import React, {
  createContext,
  useContext,
  useState,
  Dispatch,
  SetStateAction,
} from 'react';
import { IQueryDetectionsPaginated } from '../queries';
import { SantizedDetection, DetectionQueryVariables } from '../pages';
import { Detection } from '@investigator/shared/generated/graphql';

interface DetectionContextProps {
  selectedItem?: Detection | SantizedDetection;
  setSelectedItem: Dispatch<
    SetStateAction<Detection | SantizedDetection | undefined>
  >;
  detectionData?: Detection | SantizedDetection;
  setDetectionData: Dispatch<
    SetStateAction<Detection | SantizedDetection | undefined>
  >;
  detectionsData?: IQueryDetectionsPaginated;
  setDetectionsData: Dispatch<
    SetStateAction<IQueryDetectionsPaginated | undefined>
  >;
  queryVariables?: DetectionQueryVariables;
  setQueryVariables: Dispatch<
    SetStateAction<DetectionQueryVariables | undefined>
  >;
}

const DetectionContext = createContext<DetectionContextProps | undefined>(
  undefined,
);

export const useDetectionContext = () => {
  const context = useContext(DetectionContext);
  if (!context) {
    throw new Error(
      'useDetectionContext must be used within a DetectionProvider',
    );
  }
  return context;
};

export const DetectionProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [selectedItem, setSelectedItem] = useState<
    Detection | SantizedDetection
  >();
  const [detectionData, setDetectionData] = useState<
    Detection | SantizedDetection
  >();
  const [detectionsData, setDetectionsData] =
    useState<IQueryDetectionsPaginated>();
  const [queryVariables, setQueryVariables] =
    useState<DetectionQueryVariables>();

  return (
    <DetectionContext.Provider
      value={{
        selectedItem,
        setSelectedItem,
        detectionData,
        setDetectionData,
        detectionsData,
        setDetectionsData,
        queryVariables,
        setQueryVariables,
      }}
    >
      {children}
    </DetectionContext.Provider>
  );
};

export { DetectionContext };
